<ng-template storeHost></ng-template>